import { useFilePreview } from '../../File'
import { ICON_HEIGHT_40, IconSpinner } from '../../Icon'
import { PdfViewer } from '../../PdfViewer'
import { Skeleton } from '../../Skeleton'
import { FilePreview } from '../FilePreview'
import { FILES_PREVIEW_PDF_PERMANENT_API_PARAMS } from '../FilesPreviewGallery.constants'

import * as styles from './PdfPreview.module.css'

function PdfPreview({
  className = styles.PdfPreview,
  downloadFileDocument,
  file: pdf,
  getFileById,
  isSkeleton,
  pdfViewerProps,
  scope,
  subject,
}) {
  const { file, loading } = useFilePreview({
    apiParams: {
      ...FILES_PREVIEW_PDF_PERMANENT_API_PARAMS,
      object_id: subject,
      scope,
    },
    file: pdf,
    getFileById,
  })

  const loadingComponent = isSkeleton ? (
    <Skeleton className={styles.skeleton} />
  ) : (
    <IconSpinner size={ICON_HEIGHT_40} />
  )

  return (
    <div className={className}>
      {!file || loading ? (
        loadingComponent
      ) : (
        <PdfViewer
          {...pdfViewerProps}
          DocumentLoadError={FilePreview}
          documentLoadErrorProps={{
            downloadFileDocument,
            file,
            scope,
            subject,
          }}
          file={file}
        />
      )}
    </div>
  )
}

export default PdfPreview
